import NotFooterLayout from "layouts/NotFooterLayout";
import CreateCampaign from "components/Campaign/CreateCampaign";

function CreateCampaignPage() {
  return (
    <>
      <NotFooterLayout namePage="เพิ่มแคมเปญ"  >
        <div className="layout-content">
          <CreateCampaign />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default CreateCampaignPage;
